import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { SobreviventeListPage } from '@/features/sobrevivente/components/SobreviventeListPage'

export const Route = createFileRoute('/_authenticated/sobrevivente/')({
  component: SobreviventeIndex,
})

function SobreviventeIndex() {
  return (
    <>
      <AppHeader title="Sobrevivente" />
      <SobreviventeListPage />
    </>
  )
}
